var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      class: _vm.bemBlock,
      style: _vm.cssCustomProps
    },
    [_c("div", { class: _vm.bemElement("thumb") })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }